import { createEntityAdapter, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { DatePeriodEnum } from '_store/utils';
import {
  CreateIVIMPayload,
  DisableIVIMPayload,
  GetIVIMListPaylaod,
  UpdateIVIMPayload,
} from '../../lib/api';
import {
  Ivim,
  IvimDateFilterType,
  IvimReducerState,
  IvimSourceFilter,
  IvimStatusFilter,
} from './ivimsTypes';

const initialState: IvimReducerState = {
  loading: false,
  loadingCSV: false,
  statusFilter: IvimStatusFilter.IN_PROGRESS,
  sourceFilter: [IvimSourceFilter.EMERAS],
  dateFilter: DatePeriodEnum.lastDay,
  updatedFromFilter: null,
  updatedToFilter: null,
  dateFilterType: IvimDateFilterType.RELATIVE,
  roadSegmentId: null,
  total: 0,
  paginationCurrentPage: 1,
  paginationItemsPerPage: 10,
  serviceCategoryCodeFilter: null,
  serviceSubCategoryCodeFilter: null,
  allData: [],
};

export const ivimsAdapter = createEntityAdapter({
  selectId: (el: Ivim) => el.id,
});

const ivimsReducer = createSlice({
  name: 'ivims',
  initialState: ivimsAdapter.getInitialState(initialState),
  reducers: {
    ivimsRequest: (state, _action: PayloadAction<GetIVIMListPaylaod>) => {
      const {
        date,
        updatedFrom,
        updatedTo,
        status,
        sources,
        currentPage,
        serviceCategoryCode,
        serviceSubCategoryCode,
        itemsPerPage,
        getAllData,
      } = _action.payload;

      if (getAllData) {
        state.loadingCSV = true;
      } else {
        state.loading = true;
      }

      if (date) {
        state.dateFilter = date;
      }

      state.updatedFromFilter = updatedFrom ? updatedFrom : state.updatedFromFilter;
      state.updatedToFilter = updatedTo ? updatedTo : state.updatedToFilter;
      if (currentPage) {
        state.paginationCurrentPage = currentPage;
      }
      if (serviceCategoryCode) {
        state.serviceCategoryCodeFilter = serviceCategoryCode;
      }
      if (serviceSubCategoryCode) {
        state.serviceSubCategoryCodeFilter = serviceSubCategoryCode;
      }
      if (itemsPerPage) {
        state.paginationItemsPerPage = itemsPerPage;
      }

      state.statusFilter = status !== undefined ? status : state.statusFilter;
      state.sourceFilter = sources ? (sources.length === 0 ? [] : sources) : state.sourceFilter;
    },
    ivimsResponse: (state, action) => {
      if (state.loading) {
        ivimsAdapter.setAll(state, action.payload.results);
        state.total = action.payload.total;
        state.loading = false;
      } else if (state.loadingCSV) {
        state.allData = action.payload.results;
        state.loadingCSV = false;
      }
    },
    ivimsAddOne: ivimsAdapter.addOne,
    ivimsAddMany: ivimsAdapter.addMany,
    ivimUpdate: ivimsAdapter.updateOne,

    ivimRemove: ivimsAdapter.removeOne,
    ivimRemoveMany: ivimsAdapter.removeMany,

    ivimUpsertOne: ivimsAdapter.upsertOne,
    ivimUpsertMany: ivimsAdapter.upsertMany,

    createIVIM: (state, _action: PayloadAction<CreateIVIMPayload>) => {
      state.loading = true;
    },
    updateIVIM: (state, _action: PayloadAction<UpdateIVIMPayload>) => {
      state.loading = true;
    },
    deleteIVIM: (state, _action: PayloadAction<string>) => {
      state.loading = true;
    },
    resetLoading: (state) => {
      state.loading = false;
    },
    deleteIVIMs: (state, _action: PayloadAction<string[]>) => {
      state.loading = true;
    },
    disableIVIM: (state, _action: PayloadAction<DisableIVIMPayload>) => {
      state.loading = true;
    },
    changeDateFilterType: (state, _action: PayloadAction<IvimDateFilterType>) => {
      state.dateFilterType = _action.payload;
    },
  },
});

export default ivimsReducer;
